import { resourcesUrl } from "../../../shared/config";
import ImageGallery from "../../../ui/components/ImageGallery";
import ImageWithBackdrop from "../../../ui/components/ImageWithBackdrop";
import clsx from "clsx";

export default function ImagePostContent({ postData, className }) {
  const foo = postData?.carrossel?.replaceAll("\\", "/").split(",");
  const imgSrcs = foo?.map((srcs) =>
    srcs.includes("http") ? srcs : `${resourcesUrl}/${srcs}`
  );
  if (!!imgSrcs && imgSrcs.length > 1) {
    return (
      <div
        className={clsx("post_content", className)}
        aspectRatio={postData.proporcaoImagem || " 4 / 5"}
      >
        <ImageGallery imgSrcs={imgSrcs} />
      </div>
    );
  }

  if (!!imgSrcs?.[0]) {
    return (
      <div
        className={clsx("post_content", className)}
        aspectRatio={postData.proporcaoImagem || " 4 / 5"}
      >
        <ImageWithBackdrop url={imgSrcs[0]} />
      </div>
    );
  }
  return <div className="post_content"></div>;
}
